import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3333 8.63341V7.36675C14.3333 4.67974 14.3333 3.33624 13.4058 2.50149C12.4783 1.66675 10.9855 1.66675 7.99996 1.66675C5.0144 1.66675 3.52162 1.66675 2.59412 2.50149C1.66663 3.33624 1.66663 4.67974 1.66663 7.36675V8.63341C1.66663 11.3204 1.66663 12.6639 2.59412 13.4987C3.52162 14.3334 5.0144 14.3334 7.99996 14.3334C10.9855 14.3334 12.4783 14.3334 13.4058 13.4987C14.3333 12.6639 14.3333 11.3204 14.3333 8.63341Z"
        stroke="#637381"
      />
      <path
        d="M12 5.33333H9.33337M10.6667 4V6.66667"
        stroke="#637381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 11.6667H9.33337" stroke="#637381" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 9.66675H9.33337" stroke="#637381" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.66671 11.6666L5.50004 10.4999M5.50004 10.4999L4.33337 9.33325M5.50004 10.4999L6.66671 9.33325M5.50004 10.4999L4.33337 11.6666"
        stroke="#637381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.66667 5.33325H4" stroke="#637381" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default SvgComponent
